import SalesListSettingsForm from './SalesListSettingsForm';

function SalesListSettingsModal({
    show,
    allowedPlants,
    customers,
    initialSettings,
    onSave,
    onClose,
}) {
    if (!show) {
        return null;
    }

    return (
        <>
            <div className="modal-backdrop fade show" />
            <div className="modal fade show sales-settings-modal-wrap" style={{ display: 'block' }} tabIndex="-1">
                <div className="modal-dialog modal-lg sales-settings-modal-dialog">
                    <div
                        className="modal-content sales-settings-modal"
                        onMouseDown={(event) => event.stopPropagation()}
                    >
                        <div className="modal-body">
                            <h4 className="text font-weight-bold page-title">General Settings for Sales</h4>
                            <SalesListSettingsForm
                                allowedPlants={allowedPlants}
                                customers={customers}
                                initialSettings={initialSettings}
                                onSave={onSave}
                                onCancel={onClose}
                                showSectionHeader={false}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SalesListSettingsModal;
